<template>
    <div class="navbar-item">
        <router-link
            :to="url"
            class="p-2"
        >
            <div class="flex items-center navbar-item__link-content">
                <div class="whitespace-no-wrap navbar-item__link-name">{{name}}</div>
            </div>
        </router-link>
    </div>
</template>

<script>
import {mixins} from '../../mixins'
export default {
    mixins: [mixins],
    props: {
        name: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        method: {
            type: String,
            required: true
        }
    },
}
</script>

<style lang="scss">
.navbar-item {
    a {
        display: block;
    }
}
</style>
